export function jsonToParams(obj: any){
    const params = new URLSearchParams()
    
    function buildParams(key: any, value: any) {
        if (Array.isArray(value)) {
            value.forEach(item => params.append(`${key}[]`, item))
        } else if (typeof value === 'object') {
            Object.keys(value).forEach(subKey => {
                buildParams(`${key}[${subKey}]`, value[subKey])
            })
        } else {
            params.append(key, value)
        }
    }
    
    Object.keys(obj).forEach(key => buildParams(key, obj[key]))
    return params.toString()
}